import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useRef, useEffect, useState } from 'react';
import { useClickOutsideCallback } from '../hooks/use-click-outside-callback';
import DefaultTheme from './theme';
export var Theme = DefaultTheme;
/*::
import type { Node, ElementRef, ElementType } from 'react';

export type PopupTheme = {|
  Main: * => Node,
  Background: * => Node,
|};

type Props = {|
  visible?: boolean,
  autoUpwards?: boolean,
  inContext?: boolean,
  onClose: * => any,
  ignoreRefs?: {
    current: Array<{
      current: null | ElementRef<any>
    }>
  },
  children: Node,
  theme?: PopupTheme,
  enableBackground?: boolean,
  rest?: any,
|};
*/

var Popup = function Popup(_ref
/*: Props */
) {
  var _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$autoUpwards = _ref.autoUpwards,
      autoUpwards = _ref$autoUpwards === void 0 ? false : _ref$autoUpwards,
      _ref$inContext = _ref.inContext,
      inContext = _ref$inContext === void 0 ? false : _ref$inContext,
      onClose = _ref.onClose,
      children = _ref.children,
      _ref$ignoreRefs = _ref.ignoreRefs,
      ignoreRefs = _ref$ignoreRefs === void 0 ? {} : _ref$ignoreRefs,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      _ref$enableBackground = _ref.enableBackground,
      enableBackground = _ref$enableBackground === void 0 ? false : _ref$enableBackground,
      rest = _objectWithoutPropertiesLoose(_ref, ["visible", "autoUpwards", "inContext", "onClose", "children", "ignoreRefs", "theme", "enableBackground"]);

  var node = useRef();

  var _useState = useState({
    top: null
  }),
      top = _useState[0].top,
      setTop = _useState[1];

  var _useState2 = useState({
    innerVisible: visible
  }),
      innerVisible = _useState2[0].innerVisible,
      setInnerVisible = _useState2[1];

  useClickOutsideCallback(node, function (e) {
    var ignoreClickOutside = ignoreRefs && ignoreRefs.current && ignoreRefs.current.some(function (ref) {
      return ref && ref.current && ref.current.contains(e.target);
    });
    if (ignoreClickOutside) return;
    onClose(e);
  }, [visible, onClose]);

  var getViewPortHeight = function getViewPortHeight() {
    return (
      /*: number */
      document.documentElement && document.documentElement.clientHeight || window.innerHeight
    );
  };

  var isOutOfViewport = function isOutOfViewport()
  /*: boolean */
  {
    var popupTop = node.current ? node.current.getBoundingClientRect().top : 0;
    var popupHeight = node.current ? node.current.offsetHeight : 0;
    return popupTop + popupHeight > getViewPortHeight();
  };

  useEffect(function () {
    setTop({
      top: autoUpwards && visible && isOutOfViewport() && node.current ? -node.current.offsetHeight : null
    });
    setInnerVisible({
      innerVisible: visible
    });
  }, [visible, autoUpwards]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, enableBackground && /*#__PURE__*/React.createElement(theme.Background, {
    visible: innerVisible
  }), /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    ref: node,
    visible: innerVisible,
    top: top,
    inContext: inContext,
    "data-test": "popup-main"
  }, rest), children));
};

export default Popup;